import { httpClient } from '@api/interceptors';

export const stopParkingSpot = async (id: string): Promise<void> => {
  return httpClient.delete(`parkings/${id}`).json();
};
